import React from 'react'
import { graphql } from 'gatsby'
import MainLayout from '../../layouts/Main'

const Main = props => {
  return <MainLayout {...props} lang="en" />
}

export default Main

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/en/changelog/" } }
      sort: { order: DESC, fields: frontmatter___date }
      limit: 3
    ) {
      edges {
        node {
          frontmatter {
            app
            changeType
            title
            date
          }
          fields {
            slug
            langKey
          }
        }
      }
    }
  }
`
